import { createNavbarMenuItem } from "@frontends-v3/shared-core";
import { NavbarMenuItemType } from "@frontends-v3/design-system";

import { SECTION_MATCH_ROUTES } from "./nav-sections";

/**
 * Fonte única das seções da Plataforma, lida pelo menu lateral e pela barra inferior. O leitor (Aluno,
 * Família) não tem Início nem Turmas — entra direto em Atribuições (DEV-1104, R1).
 */
export function buildPlatformNavItems(isReader: boolean): NavbarMenuItemType[] {
  const action: NavbarMenuItemType = {
    ...createNavbarMenuItem("action", "Atribuições", "clipboard-check", "/action"),
    matchRoutes: [...SECTION_MATCH_ROUTES["/action"]]
  };
  const library = createNavbarMenuItem("library", "Biblioteca", "book", "/library");

  if (isReader) return [action, library];

  return [
    createNavbarMenuItem("home", "Início", "home", "/"),
    action,
    library,
    createNavbarMenuItem("class", "Turmas", "users-alt", "/class")
  ];
}
